import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormInput from '../../../../../library/form/components/FormInput';
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const DesignSearchPriceINVAction = (props) => {
    const { formObject, selectedDids, reloadSearch } = props;

    const onActionSuccess = () => {
        if(reloadSearch)reloadSearch(1);
    }

    // const onPopupClose = () => {
    //     if(reloadSearch)reloadSearch(1);
    // }

    return (
        <div>
            <div className="uiEditableContent">
                <span><SarasTrans value="Set Price" /></span>
                <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "70px" }}
                    placeholder="Value" action={{ InputType: "input", paramName: "itemPrice" }}
                />
                <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "70px" }}
                    placeholder="Currency" action={{ InputType: "ac", paramName: "priceCurrency", acMethod:"CurrencyName" }}
                />               
                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                    action={{ actionId: "save", actionMessage: "Processing Action", actionName: "itemComp", actionParam: { ops: 1, dIds:selectedDids.join(",") },onSuccess:onActionSuccess }}
                    text={<SarasTrans value="Update" />}>
                </FormButton>
            </div>
        </div>
    )
}

export default withView(DesignSearchPriceINVAction, "", "");
